import BaseRound from '../baseRound';
import { NODE_ATTRIBUTES as ATTRIBUTES } from './advent.types';

/**
 * @typedef {import('./advent.types').AdventNodeOptions} AdventNodeOptions
 *
 * @class
 * @extends BaseRound<AdventNodeOptions>
 */
export default class AdventNode extends BaseRound {
	defaults() {
		return {
			...super.defaults(),
			[ATTRIBUTES.url]: '',
			[ATTRIBUTES.engine]: undefined,
			[ATTRIBUTES.name]: '',
			[ATTRIBUTES.customerUnlockTime]: '',
			[ATTRIBUTES.unlockTimeIsUTC]: false,
			[ATTRIBUTES.text]: '',
			[ATTRIBUTES.backgroundImg]: '',
			[ATTRIBUTES.foregroundImg]: '',
			[ATTRIBUTES.dateImg]: '',
			[ATTRIBUTES.lockedImg]: '',
			[ATTRIBUTES.completedImg]: '',
			[ATTRIBUTES.badgeImg]: '',
		};
	}
}
